import * as React from 'react';
import { IListFilterProps } from '../../../core';
import { FilterValue } from '../../api';
import classnames from 'classnames';

interface IToggleFilterProps extends IListFilterProps<boolean> {
  value?: FilterValue<boolean>;
}

const ToggleFilter: React.FunctionComponent<IToggleFilterProps> = (props) => {
  const onSelect = (sel: boolean) => {
    if (sel) {
      props.applyFilter?.({ label: props.label, value: true });
    } else {
      props.applyFilter?.(undefined);
    }
  };

  return (
    <>
      <li
        className={classnames({
          'col-auto filter-choice py-1': true,
          'cursor-pointer': !props.value?.value,
        })}
        onClick={!props.value?.value ? () => onSelect(true) : undefined}
      >
        <div
          className={classnames({
            'font-xs rounded-lg text-nowrap font-weight-semibold d-flex align-items-center p-2': true,
            'bg-primary text-white ': props.value?.value,
            'bg-light text-black border': !props.value?.value,
          })}
        >
          <span className="filter-hd px-1">{props.label}</span>
          {props.value?.value && (
            <span
              className="filter-choice-delete icon-close-round font-base pl-2 cursor-pointer"
              onClick={() => onSelect(!props.value?.value)}
            ></span>
          )}
        </div>
      </li>
    </>
  );
};

export default ToggleFilter;
